import { useEffect } from 'react'
import { clearShopProductSelection } from './use-admin-section-routing/clearShopProductSelection'
import { ensureLoginRedirect } from './use-admin-section-routing/ensureLoginRedirect'
import { hydrateSectionFromLocation } from './use-admin-section-routing/hydrateSectionFromLocation'
import { syncLocationForAuthenticatedSection } from './use-admin-section-routing/syncLocationForAuthenticatedSection'
import type { UseAdminSectionRoutingParams } from './useAdminSectionRouting.types'

export const useAdminSectionRouting = ({
  isAuthenticated,
  sessionBootstrapLoading,
  section,
  setSection,
  selectedUserId,
  setSelectedUserId,
  selectedShopProductId,
  setSelectedShopProductId,
  pageEditorMode,
  setPageEditorMode,
  pageEditorId,
  setPageEditorId,
}: UseAdminSectionRoutingParams) => {
  useEffect(() => {
    hydrateSectionFromLocation({
      setSection,
      setSelectedUserId,
      setSelectedShopProductId,
      setPageEditorMode,
      setPageEditorId,
    })
  }, [setPageEditorId, setPageEditorMode, setSection, setSelectedShopProductId, setSelectedUserId])

  useEffect(() => {
    ensureLoginRedirect(isAuthenticated, sessionBootstrapLoading)
  }, [isAuthenticated, sessionBootstrapLoading])

  useEffect(() => {
    syncLocationForAuthenticatedSection({
      isAuthenticated,
      section,
      selectedUserId,
      selectedShopProductId,
      pageEditorMode,
      pageEditorId,
    })
  }, [
    isAuthenticated,
    pageEditorId,
    pageEditorMode,
    section,
    selectedShopProductId,
    selectedUserId,
  ])

  useEffect(() => {
    clearShopProductSelection(section, selectedShopProductId, setSelectedShopProductId)
  }, [section, selectedShopProductId, setSelectedShopProductId])
}
